<template>
  <div class="sale-card" @click="handleViewSaleEntry(sale)">
    <div>
      <sale-info :sale="sale" />
      <div class="sale-name">{{ sale.saleName }}</div>
    </div>
    <div class="text-gray">
      <div>募集締切：{{ formatDate(sale.applicationPeriodTo) }}</div>
      <div>セールID：{{ sale.saleId }}</div>
    </div>
  </div>
</template>

<script>
import SaleInfo from './SaleInfo'
import moment from 'moment'
import 'moment/locale/ja'

export default {
  components: {
    SaleInfo
  },
  props: {
    sale: {
      type: Object
    }
  },
  created () {
    moment.locale('ja')
  },
  methods: {
    formatDate (date) {
      if (!date) {
        return '・・・'
      }
      return moment(date).format('M月D日 HH:mm:ss')
    },
    handleViewSaleEntry (sale = null) {
      const params = { saleId: sale.saleId }
      this.$router.replace({ params })
    }
  }
}
</script>
<style scoped>
.text-gray {
  color: #666;
}
.sale-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: white;
  border: 1px solid #ccc;
  padding: 10px;
  margin-bottom: 20px;
  position: relative;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  cursor: pointer;
}
.sale-card:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  background-color: #d1f3ff;
  border-color: #3eadfc;
  opacity: 0.8;
}
.sale-name {
  color: #5b9bd5;
  font-size: 20px;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/view/sale/components/SaleCard.vue